import Instagram from "../assets/svg/Instagram";
import Github from "../assets/svg/Github";
import Facebook from "../assets/svg/Facebook";
import LinkedIn from "../assets/svg/LinkedIn";
import Twitter from "../assets/svg/Twitter";
import Discord from "../assets/svg/Discord";
import Mail from "../assets/svg/Mail";
import Whatsapp from "../assets/svg/Whatsapp";
import HAMMAD from "../assets/profile/hammad.jpg";
import Fiverr from "../assets/svg/Fiverr";
import HackerRank from "../assets/svg/HackerRank";
import Upwork from "../assets/svg/Upwork";

export const selfContact = [
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "2 Profiles",
    link: "https://upwork.com/freelancers/~01e0a51cb5c5d9544b",
    name: "Hammad Aslam",
    media: <Upwork />,
    class: "upworkSVG",
    mediaName: "Upwork",
    bg: "#43be13",
  },
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "3 Gigs",
    link: "https://www.fiverr.com/hammadaslam10",
    name: "Hammad Aslam",
    media: <Fiverr />,
    class: "fiverrSVG",
    mediaName: "Fiverr",
    bg: "#1dbf73",
  },
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "320+ Followers",
    link: "https://instagram.com/hammadaslam10",
    name: "حماد راجپوت",
    media: <Instagram />,
    class: "instagramSVG",
    mediaName: "Instagram",
    bg: "#dc2743",
  },
  {
    handle: "@hammadaslam1",
    imageSrc: HAMMAD,
    followers: "30+ Repositories",
    link: "https://github.com/hammadaslam1",
    name: "Hammad Aslam",
    media: <Github size={50} />,
    class: "githubSVG",
    mediaName: "Github",
    bg: "#2a2b2f",
  },
  {
    handle: "@hammadaslam101",
    imageSrc: HAMMAD,
    followers: "600+ Followers",
    link: "https://web.facebook.com/hammadaslam101",
    name: "حماد راجپوت",
    media: <Facebook size={65} />,
    class: "facebookSVG",
    mediaName: "Facebook",
    bg: "#0044ff",
  },
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "700+ Connections",
    link: "https://www.linkedin.com/in/hammadaslam10/",
    name: "Hammad Aslam",
    media: <LinkedIn />,
    class: "linkedinSVG",
    mediaName: "LinkedIn",
    bg: "#0044ff",
  },
  {
    handle: "hammadaslam308@gmail.com",
    imageSrc: HAMMAD,
    followers: "",
    link: "mailto:hammadaslam308@gmail.com",
    name: "Hammad Aslam",
    media: <Mail />,
    class: "gmailSVG",
    mediaName: "Gmail",
    bg: "#c71610",
  },
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "",
    link: "https://discordapp.com/users/1061504929681911879",
    name: "Hammad Aslam",
    media: <Discord />,
    class: "discordSVG",
    mediaName: "Discord",
    bg: "#5b71c0",
  },
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "",
    link: "https://www.hackerrank.com/profile/hammadaslam10",
    name: "Hammad Aslam",
    media: <HackerRank />,
    class: "hackerSVG",
    mediaName: "HackerRank",
    bg: "#2ec866",
  },
  {
    handle: "@hammadaslam_10",
    imageSrc: HAMMAD,
    followers: "",
    link: "https://twitter.com/hammadaslam_10",
    name: "محمد حماد اسلم",
    media: <Twitter />,
    class: "twitterSVG",
    mediaName: "Twitter",
    bg: "#326ada",
  },
  {
    handle: "@hammadaslam10",
    imageSrc: HAMMAD,
    followers: "1 Channel (Mad Coder)",
    link: "https://wa.me/qr/7R7TGR2TSQAEE1",
    name: "Hammad Aslam",
    media: <Whatsapp />,
    class: "whatsappSVG",
    mediaName: "WhatsApp",
    bg: "#25d366",
  },
];
